<template>
    <div class="signBox">
        <breadcrumb :routerList="[{to:'/agent/agentCopy',title:'经销商管理'},{title:'经销商审查'}]"/>
        <div class="imgBox" v-loading="loading">
            <div class="whiteBox">
                <div class="titles">账户信息</div>
                <div class="signsign">
                    <div class="h-formLine" style="margin-top:0.38rem">
                        <el-form :model="supplier.bscUserInfo" label-position="right" ref="supplier1" :rules="rules2" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                            <el-form-item label="用户名" class="h-elformWrap-2" prop="username">
                                <el-input v-model="supplier.bscUserInfo.username" placeholder="请填写"></el-input>
                            </el-form-item>
                            <el-form-item label="密码" class="h-elformWrap-2" prop="password">
                                <el-input type="password" v-model="supplier.bscUserInfo.password" placeholder="请填写"></el-input>
                            </el-form-item>
                            <div style="float:right;display:inline-block;margin-right:17px;">
                                <el-form :model="check" label-position="right" ref="supplier2"
                                        :inline="true" :rules="rules2" class="demo-ruleForm h-formbLine h-formbLine1">
                                    <el-form-item label="确认密码" class="h-elformWrap-1" prop="checkpassword" style="margin-right:5px;">
                                        <el-input type="password" v-model="check.checkpassword" placeholder="请填写" style="width:2.4rem;margin-top:-30px;"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
<!--                            <el-form-item label="纳税人登记号" class="h-elformWrap-2" prop="companycode">-->
<!--                                <el-input placeholder="请输入" v-model="supplier.bscUserInfo.companycode"></el-input>-->
<!--                            </el-form-item>-->
                        </el-form>
                       
                        <el-form :model="supplier.bscUserInfoSupplierCopy" label-position="right" ref="supplier3" :rules="rules2" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>基本信息</h1>
                                    </div>

                                    <div class="h-pieceCon2">
                                        <div class="h-formLine weekplandetail">
                                            <el-form-item label="供应商名称" class="h-elformWrap-2" prop="userName">
                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.userName"></el-input>
                                            </el-form-item>

                                            <el-form-item label="街道/房号" class="h-elformWrap-2" prop="inStreetRoom">
                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.inStreetRoom"></el-input>
                                            </el-form-item>
<!--                                            <el-form-item label="邮政编码" class="h-elformWrap-2" prop="inPostalCodeCity">-->
<!--                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.inPostalCodeCity"></el-input>-->
<!--                                            </el-form-item>-->
<!--                                            <el-form-item label="供应商账户组" class="h-elformWrap-2" prop="InAccountGrpCode">-->
<!--                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.InAccountGrpCode"></el-input>-->
<!--                                            </el-form-item>-->
                                            <el-form-item label="对应公司代码" class="h-elformWrap-2" prop="subCompany">
                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.subCompany"></el-input>
                                            </el-form-item>
                                            <el-form-item label="电话" class="h-elformWrap-2" prop="inPhoneNumber">
                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.inPhoneNumber"></el-input>
                                            </el-form-item>
                                            <el-form-item label="国家" class="h-elformWrap-2" prop="inCountry">
                                                <brselectlazy category="YLCountry_agent" :v="supplier.bscUserInfoSupplierCopy.inCountry" v-model="supplier.bscUserInfoSupplierCopy.inCountry" :clearable="true"
                                                              style="width:100%" />
                                            </el-form-item>
                                            <el-form-item label="地区" class="h-elformWrap-2" prop="inRegion" v-if="this.supplier.bscUserInfoSupplierCopy.inCountry == 'CN'">
                                                <brselectlazy category="YLRegion" :v="supplier.bscUserInfoSupplierCopy.inRegion" v-model="supplier.bscUserInfoSupplierCopy.inRegion" :clearable="true"
                                                              style="width:100%" />
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>公司信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine weekplandetail">
                                            <el-form-item label="公司代码" class="h-elformWrap-2" prop="companyCode">
                                                <brselectlazy category="YlCompanyCode_agent" :v="supplier.bscUserInfoSupplierCopy.companyCode" v-model="supplier.bscUserInfoSupplierCopy.companyCode" :clearable="true"
                                                              style="width:100%" />
                                            </el-form-item>
<!--                                            <el-form-item label="统驭科目" class="h-elformWrap-2" prop="reconcileAccount">-->
<!--                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.reconcileAccount"></el-input>-->
<!--                                            </el-form-item>-->
<!--                                            <el-form-item label="付款条件" class="h-elformWrap-2" prop="paymentTerm">-->
<!--                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.paymentTerm"></el-input>-->
<!--                                            </el-form-item>-->
<!--                                            <el-form-item label="付款方式" class="h-elformWrap-2" prop="paymentMethod">-->
<!--                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.paymentMethod" ></el-input>-->
<!--                                            </el-form-item>-->
                                        </div>
                                    </div>
                                </div>
                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>银行信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine weekplandetail">
                                            <el-form-item label="银行所属国家" class="h-elformWrap-2" prop="bankCountry">
                                                <brselectlazy category="YLCountry_agent" :v="supplier.bscUserInfoSupplierCopy.bankCountry" v-model="supplier.bscUserInfoSupplierCopy.bankCountry" :clearable="true"
                                                              style="width:100%" />
                                            </el-form-item>
                                            <el-form-item label="银行码" class="h-elformWrap-2"  prop="bankBranchCode">
                                                <brselectlazy category="BankCategory_agent" :v="supplier.bscUserInfoSupplierCopy.bankBranchCode" v-model="supplier.bscUserInfoSupplierCopy.bankBranchCode" :clearable="true"
                                                              style="width:100%" />
                                            </el-form-item>
                                            <el-form-item label="银行户主" class="h-elformWrap-2" prop="bankAccountNum">
                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.bankAccountNum"></el-input>
                                            </el-form-item>
                                            <el-form-item label="银行账户" class="h-elformWrap-2"  prop="accountHolderName">
                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.accountHolderName"></el-input>
                                            </el-form-item>
                                            <el-form-item label="订单货币" class="h-elformWrap-2"  prop="orderCurrency">
                                                <brselectlazy category="YLCurrency" :v="supplier.bscUserInfoSupplierCopy.orderCurrency" v-model="supplier.bscUserInfoSupplierCopy.orderCurrency" :clearable="true"
                                                              style="width:100%" />
                                            </el-form-item>
                                            <el-form-item label="采购组织" class="h-elformWrap-2" prop="purchaseGrpCode" >
                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.purchaseGrpCode"></el-input>
                                            </el-form-item>
                                            <el-form-item label="PI合作伙伴" class="h-elformWrap-2"  prop="partnerPi">
                                                <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.partnerPi"></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>资质信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine">
                                            <el-form-item label="请上传营业执照" class="h-elformWrap-2" prop="upload1" style="width:50%!important;">
                                                <el-upload
                                                        v-model="supplier.bscUserInfoSupplierCopy.upload1"
                                                        class="upload-zizhi"
                                                        action=""
                                                        :http-request="httpRequest1"
                                                        :on-remove="handleRemove1"
                                                        :before-remove="beforeRemove"
                                                        multiple
                                                        :file-list="fileList1"
                                                        :auto-upload=true>
                                                    <el-button size="small" type="primary">点击上传</el-button>
                                                </el-upload>
                                            </el-form-item>
                                            <el-form-item label="请上传二级资质证书" class="h-elformWrap-2" prop="upload2" style="width:50%!important;" v-if="have2">
                                                <el-upload
                                                        v-model="supplier.bscUserInfoSupplierCopy.upload2"
                                                        class="upload-demo"
                                                        action=""
                                                        :http-request="httpRequest2"
                                                        :on-remove="handleRemove2"
                                                        :before-remove="beforeRemove"
                                                        multiple
                                                        :file-list="fileList2"
                                                        :auto-upload=true>
                                                    <el-button size="small" type="primary">点击上传</el-button>
                                                </el-upload>
                                            </el-form-item>
                                           
                                            <el-form-item label="请上传三级资质证书" class="h-elformWrap-2" style="width:50%!important;" prop="upload3" v-if="have2">
                                                <el-upload
                                                        v-model="supplier.bscUserInfoSupplierCopy.upload3"
                                                        class="upload-demo"
                                                        action=""
                                                        :http-request="httpRequest3"
                                                        :on-remove="handleRemove3"
                                                        :before-remove="beforeRemove"
                                                        multiple
                                                        :file-list="fileList3"
                                                        :auto-upload=true>
                                                    <el-button size="small" type="primary">点击上传</el-button>
                                                </el-upload>
                                                    </el-form-item>
                                                </div>
                                            </div>
                                             <el-switch
													style="margin-left: 2.3rem;"
                                                    v-model="have2"
                                                    active-text=""
                                                    inactive-text="是否有二三级资质证书">
                                            </el-switch>
                                        </div>
                                    </div>
                        </el-form>
                    </div>
                    </div>
                </div>
            </div>
            <div style="text-align: center">
                <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default" :class="{'h-bgwhite':this.flag!=='2'}"  @click="goBack">返回</el-button>
                <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default" @click="insertSupplier('supplier')">提交</el-button>
            </div>
        </div>
</template>
<script>
    import ss from "../../api/SystemService";
    import uploadFile from "../../api/process/account_complainUploadService";
    export default {
        data() {
            var validatePass3 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.check.checkpassword !== '') {
                        this.$refs.supplier2.validateField('checkpassword');
                    }
                    callback();
                }
            };
            var validatePass4 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.supplier.bscUserInfo.password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            var validateCompanySupplier = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入公司名称'));
                } else if (value !== '') {
                    ss.SignService.checkCompany(value).then(response => {
                        console.log(response,'验证公司信息')
                        if (response.obj.status === '200'){
                            this.companyData = response.obj.data;
                            callback();
                            this.supplier.bscUserInfoSupplierCopy.inStreetRoom = this.companyData.address;
                            this.supplier.bscUserInfo.companycode = this.companyData.credit_no;
                            this.supplier.bscUserInfoSupplierCopy.inPhoneNumber = this.companyData.contact.telephone;
                        }else{
                            callback(new Error('请输入正确的公司名称!'));
                        }
                    })

                }
            };
            return {
                have2: false,
                have3: false,
                reftype1: '供应商注册-营业执照信息',
                reftype2: '供应商注册-二级资质信息',
                reftype3: '供应商注册-三级资质信息',
                fileList1: [],
                fileList2: [],
                fileList3: [],
                //供应商注册信息，用于传入后台注册
                supplier: {
                    bscUserInfo: {
                        usercode: null,//员工编码/公司编码
                        password: '',//密码
                        usertype: null,//用户类别: 0-内部员工  1-经销商  2-供应商
                        username: null,//公司名称/员工姓名username
                        companycode: null,//公司名称/员工姓名username
                        email: null,//邮箱
                        phone: null,//联系人电话
                        deptcode: null,//所属部门编码deptcode  公司用户为空
                        userdept: null,//用户详细部门userdept  公司用户为空
                        deptname: null,//部门名称deptname  公司用户为空
                        firstline: null,//一线经理firstline  公司用户为空
                        secondline: null,//二线经理secondline  公司用户为空
                        status: null,//用户状态: 0--禁用/冻结  1--正常  2--用户被删除
                        organization: null,//公司地址/住址机构
                        cdate: null,//创建时间
                        ldate: null,//更新时间
                        logintimes: null,//登录次数: 记录登录尝试失败次数，登录失败5次就将status改为禁止，联系运维解开
                        lastlogintime: null,//最后登录时间: 记录最后登录时间
                        accountdate: null,//账户有效期
                        area: null,//负责区域
                        lucode: null,//更新人编码
                        countrytype: null,//1- 国内  /  2- 国外   账户
                        fileId: null,//1- 国内  /  2- 国外   账户
                    },
                    bscUserInfoSupplierCopy: {
                        usercode: null,//公司编号
                        userName: '',//公司名称
                        inLanguage: null,// 语言 ,   , 扩充不用填 ,   ,
                        inStreetRoom: null,// 街道/房号 ,   , 扩充不用填 ,   ,
                        inPostalCodeCity: null,// 邮政编码 ,   , 扩充不用填 ,   ,
                        inCountry: null,// 国家 , 条件: 选择框(Country) , 扩充不用填 ,   ,
                        inRegion: null,// 地区 , 条件: 选择框(Region) , 扩充不用填 ,   ,
                        inPhoneNumber: null,// 电话 ,   , 扩充不用填 ,   ,
                        subCompany: null,// 对应公司代码 ,   , 扩充不用填（集团内法人公司供应商必填,填写该公司的4位公司代码） ,   ,
                        reconcileAccount: null,// 统驭科目 , 条件: 选择框(ReconcileAccount) 扩充 必填 通过供应商账户组和统御科目对照过程确定 ,  , 抓取表: T_VENDOR_COMPANY , 字段归属: 公司信息
                        sequenceNo: null,// 排序码 , 条件: 选择框(OrderCode) 扩充 必填 默认 001 ,  , 抓取表: T_VENDOR_COMPANY , 字段归属: 公司信息
                        paymentTerm: null,// 付款条件 , 条件: 选择框(PayTerm) 扩充 必填 默认 0000 ,  , 抓取表: T_VENDOR_COMPANY , 字段归属: 公司信息
                        paymentMethod: null,// 付款方式 , 条件: 选择框(PayMethod) 扩充 必填 默认 I ,  , 抓取表: T_VENDOR_COMPANY , 字段归属: 公司信息
                        accountHolderName: null,// 银行账户 ,   ,  , 抓取表: T_VENDOR_BANK , 字段归属: 银行信息
                        bankCountry: null,// 银行所属国家 ,   ,  , 抓取表: T_VENDOR_BANK , 字段归属: 银行信息
                        bankAccountNum: null,// 银行户主 ,   ,  , 抓取表: T_VENDOR_BANK , 字段归属: 银行信息
                        bankBranchCode: null,// 银行码 ,   ,  , 抓取表: T_VENDOR_BANK , 字段归属: 银行信息
                        purchaseGrpCode: null,// 采购组织 ,   ,  , 抓取表: T_VENDOR_PUR , 字段归属: 采购信息
                        orderCurrency: null,// 订单货币 ,   ,  , 抓取表: T_VENDOR_PUR , 字段归属: 采购信息
                        partnerPi: null,// PI合作伙伴 ,   ,  , 抓取表: T_VENDOR_PUR , 字段归属: 采购信息
                        systemName: null,// 系统名称 , 条件: 扩充 必填 填写 ALM系统编号 , 可根据需要修改 ,   , 字段归属: 通用字段
                        viewBank: null,// 是否更新银行 ,   , X代表更新 ,   , 字段归属: 通用字段
                        viewBase: null,// 是否更新基本信息 ,   , X代表更新 ,   , 字段归属: 通用字段
                        viewComp: null,// 是否更新公司信息 ,   , X代表更新 ,   , 字段归属: 通用字段
                        viewPur: null,// 是否更新采购信息 ,   , X代表更新 ,   , 字段归属: 通用字段
                        operateType: null,// 操作状态 , 条件: 扩充填写 EXTEND , 操作状态 ,   , 字段归属: 通用字段
                        createdBy: null,// 创建人 , 条件: 非必填 建议填写流程的发起人 , 创建人 ,   ,
                        cucode: null,//创建人编码
                        cuname: null,//创建人名称
                        cdate: null,//创建时间
                        lucode: null,//修改人编码
                        ldate: null,//最后更新时间
                        delflag: null,//可用标志。1：可用,0：删除标志
                        type: null,
                        upload1: [],
                        upload2: [],
                        upload3: [],
                    },
                },
                agreeIs: false,
                checked: true,
                loading: false,
                ind: null,
                index: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'],
                indexSupplier: ['1', '2', '3'],
                list: ["我是经销商", "我是供应商"],
                indx: 0,
                check: {
                    checkpassword: ''
                },
                rules2: {
                    username: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    password:
                        [
                            {required: true, validator: validatePass3, trigger: 'blur'},
                        ],
                    checkpassword:
                        [
                            {required: true, validator: validatePass4, trigger: 'blur'},
                        ],
                    userName:
                        [
                            {required: true, validator: validateCompanySupplier, trigger: 'blur'},
                        ],
                    inPhoneNumber:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    inCountry:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    inRegion:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    companycode:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    InAccountGrpCode:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    subCompany:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    companyCode:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    bankBranchCode:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    reconcileAccount:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    paymentTerm:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    paymentMethod:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    bankCountry:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    accountHolderName:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    bankAccountNum:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    accountHolderName:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    orderCurrency:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    purchaseGrpCode:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    partnerPi:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    // upload1:
                    //     [
                    //         {required: true, message: '请上传资料', trigger: 'blur'},
                    //     ],
                    upload2:
                        [
                            {required: true, message: '请上传资料', trigger: 'blur'},
                        ],
                    upload3:
                        [
                            {required: true, message: '请上传资料', trigger: 'blur'},
                        ],
                },
                query: null,
            }
        },
        created() {
            this.query = this.$route.query.type;
            console.log(this.query,'请求带来的')
        },
        methods: {
            httpRequest1(params){
                // console.log(params,"1111111111")
                const loading = this.$msg.loading("上传中...");
                uploadFile.upload(params.file, {companycode: this.supplier.bscUserInfoSupplierCopy.userName, reftype: this.reftype1}).then(rd => {
                    console.log("上传完毕后",rd);
                    loading.close();
                    this.fileList1.unshift(rd.obj);
                    this.idList.push(rd.obj.id);
                    this.supplier.bscUserInfoSupplierCopy.upload += this.supplier.bscUserInfoSupplierCopy.upload;
                }).catch(error=>{
                    loading.close();
                    this.fileList.splice(0,1);
                    return Promise.reject(error);
                });
                return false;
            },
            httpRequest2(params){
                // console.log(params,"1111111111")
                const loading = this.$msg.loading("上传中...");
                uploadFile.upload(params.file, {companycode: this.supplier.bscUserInfoSupplierCopy.userName, reftype: this.reftype2}).then(rd => {
                    console.log("上传完毕后",rd);
                    loading.close();
                    this.fileList2.unshift(rd.obj);
                    this.idList.push(rd.obj.id);
                    this.supplier.bscUserInfoSupplierCopy.upload += this.supplier.bscUserInfoSupplierCopy.upload;
                }).catch(error=>{
                    loading.close();
                    this.fileList.splice(0,1);
                    return Promise.reject(error);
                });
                return false;
            },
            httpRequest3(params){
                // console.log(params,"1111111111")
                const loading = this.$msg.loading("上传中...");
                uploadFile.upload(params.file, {companycode: this.supplier.bscUserInfoSupplierCopy.userName, reftype: this.reftype3}).then(rd => {
                    console.log("上传完毕后",rd);
                    loading.close();
                    this.fileList3.unshift(rd.obj);
                    this.idList.push(rd.obj.id);
                    this.supplier.bscUserInfoSupplierCopy.upload += this.supplier.bscUserInfoSupplierCopy.upload;
                }).catch(error=>{
                    loading.close();
                    this.fileList.splice(0,1);
                    return Promise.reject(error);
                });
                return false;
            },
            goxieyi(){
                this.agreeIs = true;
            },
            agrees(){
                this.agreeIs = false;
            },
            goBack(){
                this.$router.push({path:'/personal/supplierList'})
            },
            //提交注册供应商
            insertSupplier(formName){
                if(this.checked == true){
                    var flag = 0;
                    for (var i = 0;i<this.indexSupplier.length;i++){
                        this.ind = this.indexSupplier[i];
                        var form = formName+this.ind;
                        // console.log(form)
                        this.$refs[form].validate((valid) => {
                            if (valid) {

                            } else {
                                flag = flag+1;
                                return false;
                            }
                        });
                    }
                    // console.log(flag)
                    if (flag !== 0){
                        return false;
                    }
                    this.loading = true;
                    console.log(this.supplier,'supplier')
                    if (this.query =="1"){
                        this.supplier.bscUserInfoSupplierCopy.type = "1";
                    }else if (this.query == "2"){
                        this.supplier.bscUserInfoSupplierCopy.type = "2";
                    }
                    console.log(this.supplier.bscUserInfoSupplierCopy.type,'供应商类型')
                    ss.SignService.insertSupplier(this.supplier).then(response => {
                        if (response.f) {
                            this.$message({
                                type: "success",
                                message: response.msg
                            });
                            var defaultpage = this.$store.getters.user.defaultpage
                            this.$router.push({path: defaultpage});
                        } else {
                            this.$message({
                                type: "error",
                                message: response.msg
                            });
                            this.loading = false;
                        }
                    })
                    console.log(this.idList,this.supplier.bscUserInfoSupplierCopy.userName,this.reftype,'aaaaaaaaaaaaaaa');
                    this.updateFile.idList = this.idList;
                    this.updateFile.refid = this.supplier.bscUserInfoSupplierCopy.userName;
                    ss.SignService.updateUploadFile(this.updateFile);

                }else{
                    this.$message({
                        type:'warning',
                        message:'请您勾选‘我已同意平台协议，再进行注册！’'
                    })
                }

            },
            go(index) {
                this.indx = index;
            },
            handleRemove1(file) {
                console.log(file,"aaaaa");
                //删除文件
                var id = file.id;
                uploadFile.deleteById(id).then(response => {
                    // console.log(response,"删除")
                })
                //删除fileList数据
                // console.log(this.fileList);
                for (var i=0;i<this.fileList1.length;i++){
                    if (this.fileList1[i].id === id){
                        this.fileList1.splice(i,1);
                        // console.log(this.fileList)
                    }
                }
            },
            handleRemove2(file) {
                console.log(file,"aaaaa");
                //删除文件
                var id = file.id;
                uploadFile.deleteById(id).then(response => {
                    // console.log(response,"删除")
                })
                //删除fileList数据
                // console.log(this.fileList);
                for (var i=0;i<this.fileList2.length;i++){
                    if (this.fileList2[i].id === id){
                        this.fileList2.splice(i,1);
                        // console.log(this.fileList)
                    }
                }
            },
            handleRemove3(file) {
                console.log(file,"aaaaa");
                //删除文件
                var id = file.id;
                uploadFile.deleteById(id).then(response => {
                    // console.log(response,"删除")
                })
                //删除fileList数据
                // console.log(this.fileList);
                for (var i=0;i<this.fileList3.length;i++){
                    if (this.fileList3[i].id === id){
                        this.fileList3.splice(i,1);
                        // console.log(this.fileList)
                    }
                }
            },
            handlePreview(file) {
                console.log(file);
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				});

            },
            toLogin(){
                this.$router.push({path: '/login'})
            }
        },
        mounted() {
            this.flag = this.$route.query;
            console.log(this.flag[0]==='1','flag');
        }
    }
</script>
<style scoped>
    .imgBox {
        margin: 20px;
    }

    .bannerBox {
        width: 100%;
        padding: 0.22rem 0.38rem 0 0.32rem;
        margin: 0 auto;
    }
    .whiteBox{
        width: 100%;
        padding: 0.22rem 0.26rem;
        background-color: #ffffff;
        margin-bottom: 73px;
    }
    .titles {
        font-size: 0.16rem;
        color: #0e75e9;
        position: relative;
        padding-left: 9px;
        border-left: 0.05rem solid #0e75e9;
        font-weight: bold;
    }
</style>
<style>
    .signsign .h-formbLine .el-form-item__label{
        width: 42%!important;
    }
    .signsign .h-formbLine .el-form-item__content{
        width: 58%!important;
    }
    .signsign .h-formbLine .h-elformWrap-2{
        width: 33.3333%!important;
    }
    .weekplandetail .h-formbLine .h-elformWrap-2{
        width: 50%!important;
    }


</style>